import React from 'react';
import { View, Text } from 'react-native';
import ScoreBar from '../../ScoreBar';
import styled from 'styled-components/native';
import {
  WorkoutContainerText,
  WorkoutContainerHeaderTwo
} from '../../../styles/common-styles.js';

function StatLine({name, score}) {

  //////console.log("StatLine render");

  return (
    <StatLineContainer>
      <WorkoutContainerHeaderTwo>{name}</WorkoutContainerHeaderTwo>
      <ScoreBar score={score}/>
    </StatLineContainer>
  );
}

export const StatLineContainer = styled.View`
  width:100%;
  height:25px;
  display:flex;
  justify-content:space-between;
  align-items:center;
  flex-direction:row;
  margin-bottom:10px;
`;

export default StatLine;
